<template>
    <div class="">
        <FormCustomPage ref="form" @submitSuccess="getList"/>
        <FilterForm :fields="searchFields" @submit="search"/>
        <div class="groupButton">
            <AppButton customType="default" @click="addRotationChart">新增页面</AppButton>
        </div>
        <BasicTable  :tableData="tableData" :columns="columns" >
            <template v-slot:is_enable="{ item }">
                <CheckBox v-model="item.is_enable" @change="statusChange(item,'is_enable')" ></CheckBox>
            </template>
            <template v-slot:is_header="{ item }">
                <CheckBox v-model="item.is_header" @change="statusChange(item,'is_header')" ></CheckBox>
            </template>
            <template v-slot:is_footer="{ item }">
                <CheckBox v-model="item.is_footer" @change="statusChange(item,'is_footer')" ></CheckBox>
            </template>
            <template v-slot:is_full_screen="{ item }">
                <CheckBox v-model="item.is_full_screen" @change="statusChange(item,'is_full_screen')" ></CheckBox>
            </template>
            <template v-slot:add_time="{ item }">
                {{item.add_time*1000 | dateFormat('YYYY-MM-DD') }}
            </template>
            <template v-slot:operate="{ item }">
                <AppButton size="small" type="primary" plain @click="editRotationChart(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
                <AppButton size="small" type="primary" plain @click="delectRotationChart(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
            </template>
        </BasicTable>
    </div>
</template>

<script>
import { WebsiteService } from '../../service/website.service'
import FormCustomPage from './formCustomPage'

const columns = [
  { name: '标题', key: 'title' },
  { name: '是否含头部', key: 'is_header', type: 'custom'},
  { name: '是否含尾部', key: 'is_footer', type: 'custom'},
  { name: '是否满屏', key: 'is_full_screen', type: 'custom'},
  { name: '访问次数', key: 'access_count'},
  { name: '创建时间', key: 'add_time',type: 'custom'},
  { name: '操作', key: 'operate', type: 'custom' }
];

export default {
    name: 'customPage',
    components: { FormCustomPage },
    data() {
        return {
            pageQuery: {
                page: 1,
                page_size: 10
            },
            columns,
            searchFields: [{
                key: 'search',
                id: '1',
                type: 'input',
                name: '标题',
            },{
                key: 'is_enable',
                id: '2',
                type: 'select',
                name: '启用',
                options: [{
                    value: '1',
                    label: '是'
                },{
                    value: '0',
                    label: '否'
                }]
            },{
                key: 'is_header',
                id: '3',
                type: 'select',
                name: '头部',
                options: [{
                    value: '1',
                    label: '是'
                },{
                    value: '0',
                    label: '否'
                }]
            },{
                key: 'is_footer',
                id: '4',
                type: 'select',
                name: '尾部',
                options: [{
                    value: '1',
                    label: '是'
                },{
                    value: '0',
                    label: '否'
                }]
            },{
                key: 'is_full_screen',
                id: '5',
                type: 'select',
                name: '满屏',
                options: [{
                    value: '1',
                    label: '是'
                },{
                    value: '0',
                    label: '否'
                }]
            },{ 
                class: 'time',
                key: 'start_time',
                id: '6',
                type: 'date',
                name: '时间',
                placeholder: '起始时间'
            },{
                class: '',
                name: '~',
                key: 'end_time',
                id: '7',
                type: 'date',
                placeholder: '结束时间'
            }],
            tableData: [],
            query: []
        }
    },
    methods: {
        async getList() {
            const data = await WebsiteService.getListByCustomPage(this.pageQuery);
            this.tableData = data;
        },
        async search(val) {
            const data = await WebsiteService.getListByCustomPage(this.pageQuery,val);
            this.tableData = data;
        },
        editRotationChart(data) {
            this.$refs.form.open('edit', data);
        },
        addRotationChart() {
            this.$refs.form.open('add','');
        },
        statusChange(item,tag) {
            WebsiteService.switchCustomPageStatus(item.id,tag);
        },
        async delectRotationChart(item) {
            await WebsiteService.delectRotationChart(item.id)
            this.getList();
        }
    },
    mounted() {
    },
    async created() {
      this.getList()
    }
}
</script>

<style lang="scss">
    .rotationChart{
        .time.el-form-item{
            clear: both;
            .el-date-editor.el-input{
                width: auto;
            }
        }
    }
</style>>
    
